__turbopack_context__.v({
  "bg_container": "styles-module-scss-module__rd4kPG__bg_container",
  "bg_overlay": "styles-module-scss-module__rd4kPG__bg_overlay",
  "card": "styles-module-scss-module__rd4kPG__card",
  "contact_content": "styles-module-scss-module__rd4kPG__contact_content",
  "contact_link": "styles-module-scss-module__rd4kPG__contact_link",
  "container": "styles-module-scss-module__rd4kPG__container",
  "inner_content": "styles-module-scss-module__rd4kPG__inner_content",
  "on_listing_page": "styles-module-scss-module__rd4kPG__on_listing_page",
  "realtor_card_horizontal_large": "styles-module-scss-module__rd4kPG__realtor_card_horizontal_large",
  "realtor_card_horizontal_small": "styles-module-scss-module__rd4kPG__realtor_card_horizontal_small",
  "realtor_card_horizontal_small_stacked": "styles-module-scss-module__rd4kPG__realtor_card_horizontal_small_stacked",
  "realtor_card_office_detail": "styles-module-scss-module__rd4kPG__realtor_card_office_detail",
  "realtor_card_primary": "styles-module-scss-module__rd4kPG__realtor_card_primary",
  "realtor_img": "styles-module-scss-module__rd4kPG__realtor_img",
  "realtor_licenses": "styles-module-scss-module__rd4kPG__realtor_licenses",
  "realtor_phone": "styles-module-scss-module__rd4kPG__realtor_phone",
  "realtor_plain": "styles-module-scss-module__rd4kPG__realtor_plain",
  "realtor_subtitle": "styles-module-scss-module__rd4kPG__realtor_subtitle",
  "realtor_title": "styles-module-scss-module__rd4kPG__realtor_title",
});
